import React, { useState } from "react";
import {
  Button,
  Content,
  Dialog,
  DialogContainer,
  Divider,
  Flex,
  Heading,
  Text,
  TextArea,
  View,
} from "@adobe/react-spectrum";
import Close from "@spectrum-icons/workflow/Close";

interface CancelConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (cancelReason: string) => void;
  isScheduledWeb?: boolean;
}

const CancelConfirmationDialog: React.FC<CancelConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isScheduledWeb = false,
}) => {
  const [cancelReason, setCancelReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setCancelReason("");
    setIsSubmitting(false);
    onClose();
  };

  const handleConfirm = () => {
    if (!cancelReason.trim() || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    onConfirm(cancelReason.trim());
    setCancelReason("");
    setIsSubmitting(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <DialogContainer onDismiss={handleClose}>
      <Dialog size="M">
        <Heading>
          <Flex alignItems="center" justifyContent="space-between">
            <Text>{isScheduledWeb ? "Cancel Web Meeting" : "Cancel Callback"}</Text>
            <span
              style={{
                cursor: "pointer",
                fontSize: "24px",
                color: "#999",
                padding: "8px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "32px",
                height: "32px",
              }}
              onClick={handleClose}
            >
              <Close />
            </span>
          </Flex>
        </Heading>
        <Divider />
        <Content>
          <View padding="size-200">
            <Flex direction="column" gap="size-200">
              <Text UNSAFE_style={{ fontSize: "16px", fontWeight: "600", color: "#323232" }}>
                {isScheduledWeb
                  ? "Are you sure you want to cancel this web meeting?"
                  : "Are you sure you want to cancel this callback?"}
              </Text>

              <View>
                <Text UNSAFE_style={{ fontSize: "12px", marginBottom: "8px", display: "block" }}>
                  Reason for cancellation
                </Text>
                <TextArea
                  placeholder={
                    isScheduledWeb
                      ? "Please provide a reason for cancelling this web meeting..."
                      : "Please provide a reason for cancelling this callback..."
                  }
                  value={cancelReason}
                  onChange={setCancelReason}
                  width="100%"
                  height="size-1200"
                  UNSAFE_style={{ borderRadius: "4px" }}
                />
                {cancelReason.trim() && (
                  <Text
                    UNSAFE_style={{
                      fontSize: "12px",
                      color: "#4caf50",
                      marginTop: "4px",
                    }}
                  >
                    Reason provided
                  </Text>
                )}
              </View>

              <Flex justifyContent="end" gap="size-100" marginTop="size-200">
                <Button variant="secondary" onPress={handleClose}>
                  Close
                </Button>
                <Button
                  variant="cta"
                  onPress={handleConfirm}
                  isDisabled={!cancelReason.trim() || isSubmitting}
                >
                  {isSubmitting ? "Cancelling..." : "Confirm Cancel"}
                </Button>
              </Flex>
            </Flex>
          </View>
        </Content>
      </Dialog>
    </DialogContainer>
  );
};

export default CancelConfirmationDialog;
